import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useField } from 'formik';

const TextAreaField = (props) => {
  const [field, meta] = useField(props);

  const isRequired = props.required || props.validations?.some(validation => validation.type === "required");

  return (
    <Row className="mb-3">
      <Col md={3}>
        <label htmlFor={props.id || props.name}>
          {props.label}
          {isRequired && <span>*</span>} 
        </label>
      </Col>
      <Col md={4}>
        <textarea
          id={field.name}
          required={isRequired}
          className="formik-field"
          rows="4"

          {...field}
          {...props}
        />
        {meta.touched && meta.error ? (
          <div className="error">{meta.error}</div>
        ) : null}
      </Col>
    </Row>
  );
};

export default TextAreaField;
